import { IonButtons, IonMenuButton, IonCard, IonCardContent, IonContent, IonHeader, IonItem, IonLabel, IonPage, IonTitle, IonToolbar, IonChip, useIonRouter, IonIcon, IonFab, IonFabButton, IonSkeletonText, IonAvatar, IonImg, IonSpinner, IonRefresher, IonRefresherContent, RefresherEventDetail, useIonViewDidEnter, IonCardHeader, IonCardTitle, IonBackButton, IonButton, IonCol, IonGrid, IonRow, IonAccordion, IonAccordionGroup, useIonViewWillEnter } from '@ionic/react';
import { add, addCircleOutline, checkmarkCircleOutline, gitNetworkOutline, hourglassOutline, informationCircle, locationOutline, manOutline, peopleOutline } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { Link } from 'react-router-dom';
import { useAppContext } from '../AppProvider';
import Alert from '@mui/material/Alert';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { AlertTitle } from '@mui/material';

const Partners: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [alertVisible, setAlertVisible] = useState<boolean>(false);
    const { authKey, authenticateMember, authorizedMember, setShowLoader, level, settings, activePartners, pendingPartners, getPartnerships, textLogoLoaded, fadeInTextLogo, SWTextLogo, SWFullHorizLogo, SWTextDarkLogo } = useAppContext();
    
    const router = useIonRouter();

    const memberPhotoPath = '//api.besolowise.com/members/photos/files/';

    useIonViewWillEnter(() => { 
        setShowLoader(true);
        const authenticate = async () => {
            const authenticated = await authenticateMember();
            if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
            else {
                //const leveled =  await checkLevel();
                //console.log(leveled);
                await getPartnerships(authenticated.mt, 'all');
                window.setTimeout(() => {
                    setShowLoader(false);
                }, 2000);
            }
        };
        authenticate();
    }); 

    const statusChip = (s: string) => {
        switch(s) {
            case '0': return <IonChip color={'medium'}><IonIcon icon={hourglassOutline}></IonIcon><IonLabel>Pending</IonLabel></IonChip>
            case '1': return <IonChip color={'medium'}><IonIcon icon={hourglassOutline}></IonIcon><IonLabel> Pending</IonLabel></IonChip>
            case '2': return <IonChip color={'success'}><IonIcon icon={checkmarkCircleOutline}></IonIcon><IonLabel> Confirmed</IonLabel></IonChip>
            case '3': return <IonChip color={'danger'}><IonLabel>Error</IonLabel></IonChip>           
            default:  return <IonChip color={'warning'}><IonLabel>Unknown</IonLabel></IonChip>
        }
    };

    const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
        //setLoading(true);
        setTimeout(async () => {
            await getPartnerships(authKey.mt, 'all');
            event.detail.complete();
            //setLoading(false);
        }, 2000);
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonBackButton color={'tertiary'}>Back</IonBackButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg" id="Partners">
                
                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                <IonGrid>
                    <IonRow>
                        <IonCol size='12' sizeSm='7'>
                            <h1><IonIcon color={'secondary'} icon={manOutline}></IonIcon> My Partners<br /><span>Manage your SoloWise Partners</span></h1>
                        </IonCol>
                        <IonCol className='ion-margin-bottom top-action-button'  size='12' sizeSm='5'>                            
                            {level?.memberLevelID >= 2 &&
                                <IonButton className='ion-margin' color={'secondary'} routerLink='/account/partner/create' routerDirection='forward'><IonIcon icon={addCircleOutline} slot='start'></IonIcon> Add a New Partner</IonButton>
                            }
                        </IonCol>
                    </IonRow>
                </IonGrid>

                <IonAccordionGroup className='ion-margin'>
                    <IonAccordion value="info">
                        <IonItem slot='header' color={'light'}>
                            <IonLabel><IonIcon color={'tertiary'} icon={informationCircle} size='large'></IonIcon> What is a SoloWise Partner?</IonLabel>
                        </IonItem>
                        <div slot="content">                
                            <IonCard>
                                <IonCardContent>
                                    You can connect with other SoloWise members to become <strong>SoloWise Partners</strong>, which allows you to add your SoloWise Partners and all their emergency contacts to your Timers.
                                </IonCardContent>
                            </IonCard>
                        </div>
                    </IonAccordion>
                </IonAccordionGroup>
                
                {activePartners.length > 0
                    ? (activePartners.map((partner:any, index:any) => (                    
                        <IonCard key={index} routerDirection='forward' routerLink={`/account/partner/edit/${partner.token}`}>
                            <IonCardContent className='ion-no-padding'>
                                <IonItem lines='none'>
                                    {partner.photo == ''
                                        ? <InitialsAvatar className='initials-avatar' name={`${partner.firstName} ${partner.lastName}`} /> 
                                        : <IonAvatar slot='start'><IonImg src={partner.photoUrl} /></IonAvatar>
                                    } 
                                    <IonLabel>
                                        <h2>{partner.firstName} {partner.lastName}</h2>
                                    </IonLabel>
                                    {statusChip(partner.status)}
                                </IonItem>
                            </IonCardContent>
                        </IonCard>
                      )))
                    : <p className='ion-text-center'>You have no confirmed SoloWise Partners.</p>
                }                        
        
                {pendingPartners.length > 0 &&
                    (pendingPartners.map((partner:any, index:any) => (                    
                        <IonCard key={index} routerDirection='forward' routerLink={`/account/partner/edit/${partner.token}`}>
                            <IonCardContent className='ion-no-padding'>
                                <IonItem lines='none'>
                                    {partner.photo == ''
                                        ? <InitialsAvatar className='initials-avatar' name={`${partner.firstName} ${partner.lastName}`} /> 
                                        : <IonAvatar slot='start'><IonImg src={memberPhotoPath + 'tn-' + partner.photo} /></IonAvatar>
                                    } 
                                    <IonLabel>
                                        <h2>{partner.firstName} {partner.lastName}</h2>
                                    </IonLabel>
                                    {statusChip(partner.status)}
                                </IonItem>
                            </IonCardContent>
                        </IonCard>
                      )))
                }
            </IonContent>
        </IonPage>
    );
};

export default Partners;